<template>
  <a-form-model
    class="form"
    ref="form"
    :model="form"
    :rules="rules"
    :label-col="{span: 2}"
    :wrapper-col="{span: 22}"
  >
    <a-row :gutter="60">
      <a-col :span="16">
        <a-form-model-item
          label="店端配置"
          prop="storeConfig"
          :rules="{max: 100, message: '100字以内', trigger: 'blur' }"
        >
          <a-textarea
            v-model="form.storeConfig"
            :disabled="disabled"
            :rows="4"
            placeholder="请按需选填，100字以内。"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="16">
        <a-form-model-item
          label="奖励政策"
          prop="incentivePolicy"
          :rules="{max: 200, message: '200字以内', trigger: 'blur' }"
        >
          <a-textarea
            v-model="form.incentivePolicy"
            :disabled="disabled"
            :rows="4"
            placeholder="请按需选填，200字以内。"
          />
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model> 
</template>

<script>
export default {
  name: 'StoreConfigForm',
  props: {
    form: {
      type: Object,
      default () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        storeConfig: [
          { max: 100, message: '最多可输入100字', trigger: 'blur' }
        ],
        incentivePolicy: [
          { max: 200, message: '最多可输入200字', trigger: 'blur' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  margin-bottom: 0;
  font-size: 12px;
  line-height: 20px;
}
</style>